const bridge = () => typeof window !== "undefined" ? window.desktopOfflineKhatabook : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline khatabook storage.");
  return api;
};

export const getOfflineKhatabook = (restaurantId, partyId) =>
  requireBridge().list({ restaurantId, partyId });
export const getOfflineKhatabookOverall = (restaurantId) =>
  requireBridge().overall({ restaurantId });
export const addOfflineKhatabookEntry = (restaurantId, partyId, flow, amount, notes = "") =>
  requireBridge().add({ restaurantId, partyId, flow, amount, notes });
export const deleteOfflineKhatabookEntry = (restaurantId, entryId) =>
  requireBridge().remove({ restaurantId, entryId });
export const reconcileOfflineOrderKhatabook = (restaurantId, orderKey, payload) =>
  requireBridge().reconcileOrder({ restaurantId, orderKey, payload });
